<!--电费分摊-->
<template>
	<div class="tc_divide_Manager_body">
		<el-tabs v-model="tab" style="margin-left:50px;margin-top:30px;margin-right:50px">
			<el-tab-pane label="空调内外机配置" name="aircondition">
				<AirConditionMgr></AirConditionMgr>
			</el-tab-pane>
			<el-tab-pane label="公共用电配置(内部)" name="common">
				<CommonMgr></CommonMgr>
			</el-tab-pane>
			<el-tab-pane label="公共用电配置2(外部)" name="common2">
				<CommonMgr2></CommonMgr2>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import AirConditionMgr from "./tcDivideManagerAirCondition";
	import CommonMgr from "./tcDivideManagerCommon";
	import CommonMgr2 from "./tcDivideManagerCommon2";
	export default {
		components: {
			AirConditionMgr,
			CommonMgr,
			CommonMgr2,
		},
		props: {},
		data() {
			return {
				tab: 'aircondition',
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {}
	}
</script>
<style scoped>
	.tc_divide_Manager_body{
		width: 100%;
		height: 100%;
		background-color: white;
	}
</style>